
    import './styles.scoped.css';
    export default {
  "series": "awsui_series_1yz9c_1e3fn_5",
  "series--bar": "awsui_series--bar_1yz9c_1e3fn_6",
  "series__rect": "awsui_series__rect_1yz9c_1e3fn_6",
  "exiting": "awsui_exiting_1yz9c_1e3fn_23",
  "awsui-motion-fade-out-0": "awsui_awsui-motion-fade-out-0_1yz9c_1e3fn_1",
  "root": "awsui_root_1yz9c_1e3fn_45",
  "filter-container": "awsui_filter-container_1yz9c_1e3fn_57",
  "has-default-filter": "awsui_has-default-filter_1yz9c_1e3fn_61",
  "chart-container": "awsui_chart-container_1yz9c_1e3fn_65",
  "chart-container__vertical": "awsui_chart-container__vertical_1yz9c_1e3fn_71",
  "chart-container__horizontal": "awsui_chart-container__horizontal_1yz9c_1e3fn_77",
  "content": "awsui_content_1yz9c_1e3fn_81",
  "content--reserve-filter": "awsui_content--reserve-filter_1yz9c_1e3fn_88",
  "content--reserve-legend": "awsui_content--reserve-legend_1yz9c_1e3fn_92",
  "series--highlighted": "awsui_series--highlighted_1yz9c_1e3fn_105",
  "series__bar--highlighted": "awsui_series__bar--highlighted_1yz9c_1e3fn_106",
  "series--dimmed": "awsui_series--dimmed_1yz9c_1e3fn_110",
  "series--threshold": "awsui_series--threshold_1yz9c_1e3fn_119",
  "bar-group": "awsui_bar-group_1yz9c_1e3fn_124"
};
  